import { Component, ElementRef, ViewChild, OnInit } from "@angular/core";
import { ApiService } from "src/app/services/api.service";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { EditNameDialogComponent } from '../dialogs/edit-name-dialog/edit-name-dialog.component';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { AddDialogComponent } from'./add-dialog/add-dialog.component';
import { UpdateDialogComponent } from './update-dialog/update-dialog.component';


@Component({
    selector: 'clients',
    templateUrl: './clients.component.html',
    styleUrls: ['./clients.component.less']
})
export class ClientsComponent {
    update: { [id: string]: any; } = {};
    create: { [id: string]: any; } = {
        company: {},
        user: {},
        gateway: {},
        zone: {},
        sensor: {}
    };
    search: { [id: string]: any } = {
        sensor: ''
    };
    items: { [id: string]: any[]; } = {};
    messages: { [id: string]: String; } = {};
    sensorKinds: String[] = [];
    actionTypes: String[] = [];
    gatewayActions: { [id: string]: String; } = {};

    dataSource: MatTableDataSource<any>;
    displayedColumns: string[] = ['name', 'contactName', 'address', 'email', 'phone', 'viewClient', 'update', 'dalete'];
    pageSize = 10;
    loading: boolean;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('input') searchInput: ElementRef;

    constructor(private router: Router, private _api: ApiService,
        public dialog: MatDialog,
        private dataService: DataService) {
            localStorage.setItem('currentCompany', JSON.stringify(null));
            this.dataService.updateCompany(null)
            this.dataService.updateCompanyId(null)
        // _api.get<any>('/company').subscribe(resp => {
        //     this.items['company'] = resp.companies;
        //     if (resp.companies.length === 0) {
        //         this.dataSource = new MatTableDataSource();
        //         return;
        //       };
        //     this.dataSource = new MatTableDataSource(resp.companies.reverse());
        //     this.dataSource.sort = this.sort;
        //     this.dataSource.paginator = this.paginator;
        // }, err => {
        //     alert(err.message);
        // });

    }

    ngOnInit(): void {
        this.fetchData();
      }

    fetchData() {
        this.loading = true;
        this._api.get<any>('/company').subscribe(resp => {
            this.loading = false;
            this.items['company'] = resp.companies;
            if (resp.companies.length === 0) {
                this.dataSource = new MatTableDataSource();
                return;
              };
            this.dataSource = new MatTableDataSource(resp.companies);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        }, err => {
            alert(err.message);
        });

      }
    

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    
    
        if (this.dataSource.paginator) {
          this.dataSource.paginator.firstPage();
        }
    }

    addClient(){
            let data: any = {
              type: 'company',
              title: 'Company',
              name: '',
              function: (company) => this.addName('company', company)
            }

          const dialogRef = this.dialog.open(AddDialogComponent, {
            disableClose: true,
            data: data
            
          });
      
          dialogRef.afterClosed().subscribe(result => {
            if (result === undefined) return;
            setTimeout(() => result.name);
            this.create['company'] = {}
            this.fetchData();
          });
    }

    addName(type: string, data: any) {
        return this._api.post<any>(`/${type}`, data);
    }

    editCompanyName(company: any) {
        this.create['company'] = company
        const dialogRef = this.dialog.open(UpdateDialogComponent, {
          disableClose: true,
          data: {
            type: 'company',
            title: 'Company',
            name: company,
            function: (company) => this.editName('company', company)
          }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result === undefined) return;
          setTimeout(() => company.name = result.name);
          this.create['company'] = {}
          this.fetchData();
        });
      }

    editName(type: string, company: any) {
        return this._api.put<any>(`/${type}/${company.name._id}`, company.name);
    }

    deleteCompany(company: any) {
        this.create['company'] = company
        const dialogRef = this.dialog.open(DeleteDialogComponent, {
          disableClose: true,
          data: {
            type: 'company',
            title: 'Company',
            name: company.name,
            function: (company) => this.deleteOptions('company', company)
          }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result === undefined) return;
          setTimeout(() => company.name = result.name);
          this.create['company'] = {}
          this.fetchData();
        });
    }

    deleteOptions(type: string, name: any) {
        return this._api.delete(`/${type}/${this.create[type]._id}`)
        
    }

    viewClient(company: any) {
        this.dataService.updateCompany(company);
        localStorage.setItem('currentCompany', JSON.stringify({_id: company._id, name: company.name}));
        // localStorage.setItem('company', JSON.stringify(company));
        this.router.navigate(['client-dashboard', company._id]);
    }
    
    loadZones() {
        this.create['zone'] = {};
        this.update['zone'] = null;

        this._api.get<any>('/zone?slim=true').subscribe(resp => {
            this.items['zone'] = resp;
        }, err => {
            alert(err.message);
        });
    }

    loadSensors() {
        this.create['sensor'] = {};
        this.update['sensor'] = null;

        this._api.get<any>('/sensor').subscribe(resp => {
            this.items['sensor'] = resp.sensors.map(s => ({
                ...s,
                average: (s.average || []).join(',')
            }));
            this.sensorKinds = resp.sensorKinds;
            this.actionTypes = resp.actionTypes;
        }, err => {
            alert(err.message);
        });
    }

    showMessage(type, message, timeout = 2500) {
        this.messages[type] = message;
        setTimeout(() => {
            this.messages[type] = null;
        }, timeout);
    }

    // createTunnel() {
    //     if (!this.gatewayActions.gateway) {
    //         return;
    //     }

    //     this._api.post(`/gateway/${this.gatewayActions.gateway}/tunnel`).subscribe((resp: any) => {
    //         this.showMessage('gateway-actions', `Tunnel created: ${resp.tunnel}`, 10000);
    //     }, err => {
    //         alert(err.message);
    //     }, () => {
    //         this.gatewayActions = {};
    //     });
    // }

    // updateGateway() {
    //     if (!this.gatewayActions.gateway) {
    //         return;
    //     }

    //     this._api.post(`/gateway/${this.gatewayActions.gateway}/update`, {
    //         version: this.gatewayActions.version,
    //         branch: this.gatewayActions.branch,
    //     }).subscribe((resp: any) => {
    //         this.showMessage('gateway-actions', 'Updated!');
    //     }, err => {
    //         alert(err.message);
    //     }, () => {
    //         this.gatewayActions = {};
    //     });
    // }

    reloadGateway() {
        if (!this.gatewayActions.gateway) {
            return;
        }

        this._api.post(`/gateway/${this.gatewayActions.gateway}/reload`, {
            version: this.gatewayActions.version,
            branch: this.gatewayActions.branch,
        }).subscribe((resp: any) => {
            this.showMessage('gateway-actions', 'Reloaded!');
        }, err => {
            alert(err.message);
        }, () => {
            this.gatewayActions = {};
        });
    }

    closeAllTunnels() {
        this._api.post(`/gateway/tunnel/close`).subscribe((resp: any) => {
            this.showMessage('gateway-actions', `Closed ${resp.closed}!`);
        }, err => {
            alert(err.message);
        }, () => {
            this.gatewayActions = {};
        });
    }

    // createOrUpdate(type) {
    //     if (this.update[type]) {
    //         this.updateItem(type);
    //     } else {
    //         this.createItem(type);
    //     }
    // }

    createItem(type) {
        this._api.post<any>(`/${type}`, this.create[type]).subscribe(resp => {
            this.items[type].push(resp[type]);
            this.create[type] = {};
            this.showMessage(type, 'Created!');
        }, err => {
            alert(err);
        });
    }

    updateItem(type, name) {
        this.create[type].name = name
        this._api.put<any>(`/${type}/${this.create[type]._id}`, this.create[type]).subscribe(resp => {
            this.create[type] = {};
            this.update[type] = null;
            this.showMessage(type, 'Updated!');
            let index = this.items[type].findIndex(item => item._id === resp[type]._id);
            if (index > -1) {
                this.items[type][index] = resp[type];
            }
        }, err => {
            alert(err.message);
        });
    }

    delete(type) {
        if (!window.confirm(`Are you sure you want to delete the ${type} "${this.create[type].name}"?`)) {
            return;
        }
        this._api.delete(`/${type}/${this.create[type]._id}`, this.create[type].deleteRelation).subscribe((resp: any) => {
            let index = this.items[type].findIndex(item => item._id === resp.deleted);
            if (index > -1) {
                this.items[type].splice(index, 1);
            }
            if (this.create[type].deleteRelatedSensors) {
                this.loadSensors();
            }
            if (this.create[type].deleteRelatedZones) {
                this.loadZones();
            }
            this.create[type] = {};
            this.update[type] = null;
            this.showMessage(type, 'Deleted!');
        }, err => {
            alert(err);
        });
    }

    filterZoneByGateway(what, type) {
        return (item) => {
            return item[what] === this.create[type][what];
        }
    }

    expand(id, type, prop) {
        if (this.items[type]) {
            let found = this.items[type].findIndex(item => item._id === id);
            if (found > -1) {
                return this.items[type][found][prop];
            }
        }
        return id;
    }

    itemChanged(event) {
        console.log(event);
    }
}